import { motion } from "framer-motion";

/**
 * Reveal — scroll-triggered fade + slide up used across sections.
 */
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true, ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...props}
  >
    {children}
  </motion.div>
);

/**
 * Eyebrow + Heading block used at the top of each section.
 */
export const SectionHeading = ({ eyebrow, title, subtitle, align = "left", testid }) => (
  <div className={align === "center" ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}>
    {eyebrow && (
      <Reveal>
        <div className="flex items-center gap-3" style={align === "center" ? { justifyContent: "center" } : {}}>
          <span className="h-px w-8 bg-[#d4af37]" />
          <span className="eyebrow" data-testid={testid ? `${testid}-eyebrow` : undefined}>{eyebrow}</span>
        </div>
      </Reveal>
    )}
    <Reveal delay={0.06}>
      <h2 className="font-display text-4xl md:text-5xl tracking-tight text-[#222222] mt-5 leading-[1.05]">
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.12}>
        <p className="font-body text-base md:text-lg text-[#5b6b62] mt-5 leading-relaxed">
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
